import moment from "moment";
import { DateFormat, LinkedBrokersBlockedAction } from "./types";

export const getUserInitials = (name: string | undefined | null): string => {
  if (!name) return "?";
  const names = name.split(" ");
  return names.length > 1
    ? `${names[0][0]}${names.at(-1)?.[0]}`.toUpperCase()
    : names[0][0].toUpperCase();
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatDate = (
  date?: string | Date | null,
  dateFormat?: DateFormat,
) => {
  return date ? moment(date).format(dateFormat ?? DateFormat.ISO) : "";
};

// Unlike formatDate, renders in UTC rather than the viewer's zone — needed for a real timestamp (vs. a date-only string), which otherwise names a different calendar day west of UTC-09:30.
export const formatUtcDate = (
  date?: string | Date | null,
  dateFormat?: DateFormat,
) => {
  return date ? moment.utc(date).format(dateFormat ?? DateFormat.ISO) : "";
};

export const linkedBrokersMessageOf = (
  brokers: { name: string }[],
  action: LinkedBrokersBlockedAction = "delete",
): string => {
  const names = new Intl.ListFormat("en", {
    style: "long",
    type: "conjunction",
  }).format(brokers.map(({ name }) => name));
  const verb = brokers.length === 1 ? "pays its" : "pay their";
  return `Can't ${action} — ${names} ${verb} trades from this account.`;
};

export const pluralize = (count: number, singular: string): string =>
  count === 1 ? singular : `${singular}s`;
